<template>
	<li>
		<TnCard border>
			<div class="card-content-wrapper padding-l">
				<div class="heading margin-bottom-l">
					<div>
						<NuxtImg
							class="delivery-icon"
							:src="deliveryMethod.icon"
							:alt="deliveryMethod.name"
							height="30px"
						/>
					</div>
					<TnParagraph bold>{{ deliveryMethod.price ? `Fra ${deliveryMethod.price},-` : "0,-" }}</TnParagraph>
				</div>
				<div>
					<TnParagraph
						v-if="deliveryMethod.name.toLowerCase() === 'porterbuddy'"
						size="xs"
						>{{ deliveryDescription }}</TnParagraph
					>
					<TnParagraph
						v-if="deliveryMethod.name.toLowerCase().includes('posten')"
						size="xs"
						>Levering til poststed<br />1-3 dager</TnParagraph
					>
				</div>
			</div>
		</TnCard>
	</li>
</template>

<script>
import dateHelper from "~/helpers/dateHelper";
import { mapGetters } from "vuex";

export default defineNuxtComponent({
	name: "ECommerceDeliveryMethodCard",

	props: {
		deliveryMethod: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapGetters("ecommerce", ["firstDeliveryWindow"]),
		deliveryDescription() {
			return `Kan levere ${this.day} mellom ${dateHelper.getTime(this.deliveryWindowStart)} og ${dateHelper.getTime(this.deliveryWindowEnd)}.`;
		},
		day() {
			if (dateHelper.isToday(this.deliveryWindowStart)) {
				return "i dag";
			} else if (dateHelper.isTomorrow(this.deliveryWindowStart)) {
				return "i morgen";
			} else {
				return this.deliveryWindowStart.toLocaleDateString("nb-no", { weekday: "long", month: "long", day: "numeric" });
			}
		},
		deliveryWindowStart() {
			return new Date(this.firstDeliveryWindow.start);
		},
		deliveryWindowEnd() {
			return new Date(this.firstDeliveryWindow.end);
		},
	},
});
</script>

<style lang="scss" scoped>
.heading {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.delivery-icon {
	width: auto;
	height: 30px;
}

.card-content-wrapper {
	flex-grow: 2;
}
</style>
